import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import { FLAG_VIRTUAL_BACKGROUND } from 'constants/FeatureFlags';
import UserSettings from 'components/SettingsModal/UserSettings';
import { currentUserSelectors, featureSelectors } from '@lifesize/nucleus';

const mapStateToProps = (state, ownProps) => ({
  userProfile: currentUserSelectors.myInfo(state),
  hasCamera: !!ownProps.devices.find((d) => d.kind === 'videoinput'),
  hasMicrophone: !!ownProps.devices.find((d) => d.kind === 'audioinput'),
  vbbFeatureEnabled: featureSelectors.getFeatureFlag(state)(FLAG_VIRTUAL_BACKGROUND)
});

const mapDispatchToProps = () => ({});

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(UserSettings);

const FunctionalComponent = (props) => {
  const devices = hooks.useDevices();
  return <ConnectedComponent {...props} devices={devices} />;
};

export default FunctionalComponent;
